module.exports = __webpack_public_path__ + "media/fx-day.fe2e713a.mp3";